var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.832,
    cy: 16.6992,
    r: 15.668,
    fill: "#FEF7F5",
    stroke: "#FFE7E2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9824,
    y: 19.582,
    width: 9.40097,
    height: 1.12812,
    rx: 0.564058,
    transform: "rotate(-45.7402 12.9824 19.582)",
    fill: "#FFA2A2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7178,
    y: 20.3242,
    width: 9.40097,
    height: 1.12812,
    rx: 0.564058,
    transform: "rotate(-135.74 19.7178 20.3242)",
    fill: "#FFA2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.57d616c59bd7b192103d8b1e6836ff3f.svg";
export { ForwardRef as ReactComponent };